// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  settlementId: __t.u64().name("settlement_id"),
  postKey: __t.string().name("post_key"),
  venueX: __t.f32().name("venue_x"),
  venueZ: __t.f32().name("venue_z"),
  takenAt: __t.timestamp().name("taken_at"),
  lastDutyAt: __t.timestamp().name("last_duty_at"),
  dutyDay: __t.u32().name("duty_day"),
  dutyTodayS: __t.u32().name("duty_today_s"),
  totalDutyS: __t.u32().name("total_duty_s"),
  wageDueS: __t.u32().name("wage_due_s"),
  served: __t.u32(),
  earned: __t.i64(),
  nextCustomerAt: __t.timestamp().name("next_customer_at"),
});
